export const primaryTimeZones = [
    { id: 'America/New_York', text: 'New York (Eastern)' },
    { id: 'America/Chicago', text: 'Chicago (Central)' },
    { id: 'America/Denver', text: 'Denver (Mountain)' },
    { id: 'America/Los_Angeles', text: 'Los Angeles (Pacific)' },
    { id: 'America/Anchorage', text: 'Anchorage (Alaska)' },
    { id: 'Pacific/Honolulu', text: 'Honolulu (Hawaii)' },
    { id: 'Europe/London', text: 'London (GMT)' },
    { id: 'Europe/Paris', text: 'Paris (CET)' },
    { id: 'Europe/Helsinki', text: 'Helsinki (EET)' },
    { id: 'Australia/Sydney', text: 'Sydney (AEST)' },
    { id: 'Australia/Perth', text: 'Perth (AWST)' },
    { id: 'Asia/Singapore', text: 'Singapore' },
    { id: 'UTC', text: 'UTC' },
].map(it => ({ ...it, searchTextLc: it.text.toLowerCase() }));
const primaryTimeZonesById = Object.fromEntries(primaryTimeZones.map(tz => [tz.id, tz]));
const systemTimeZones = Intl.supportedValuesOf('timeZone')
    .filter((it) => it.indexOf('/') == it.lastIndexOf('/') && !primaryTimeZonesById[it])
    .map((it) => ({
    id: it.replace(/ .*$/, ''),
    text: it.replace(/[_]/g, ' ').replace(/\//g, ' / '),
    searchTextLc: it.replace(/[_]/g, ' ').replace(/\//g, ' / ').toLocaleLowerCase()
}));
export const timeZones = [...primaryTimeZones, ...systemTimeZones];
export const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const localTimeZone = timeZones.find(tz => tz.id == systemTimeZone) ? systemTimeZone : 'America/New_York';
